@if (Config.branch) {
  <div class="full-page-container">
    @if (!isMobile || !isLandingPage()) {
      <app-header-client></app-header-client>
    }
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    @if (!isMobile || !isLandingPage()) {
      <app-footer-client></app-footer-client>
    }
  </div>
}
